<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.29289 3.29289C6.68342 2.90237 7.31658 2.90237 7.70711 3.29289L13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071L7.70711 16.7071C7.31658 17.0976 6.68342 17.0976 6.29289 16.7071C5.90237 16.3166 5.90237 15.6834 6.29289 15.2929L11.5858 10L6.29289 4.70711C5.90237 4.31658 5.90237 3.68342 6.29289 3.29289Z"
  />
</svg>
